import { InputAdornment } from '@material-ui/core';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { IconOverlayText } from 'src/assets/icons/generationTools/IconOverlayText';
import { FieldInput } from 'src/components/FieldInput';
import { Score, SCORE_SIZE } from 'src/components/Score';

import { useStyles } from './useStyles';

const propTypes = {
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  score: PropTypes.number,
  loadingScore: PropTypes.bool,
  disabled: PropTypes.bool,
  grayoutTitle: PropTypes.bool,
};
const defaultProps = {
  className: '',
  score: null,
  loadingScore: false,
  disabled: false,
  grayoutTitle: false,
};

export const ScoredTextField = ({
  className,
  label,
  value,
  onChange,
  score,
  loadingScore,
  disabled,
  grayoutTitle,
  ...restProps
}) => {
  const styles = useStyles();

  return (
    <FieldInput
      className={cx(styles.root, className)}
      value={value}
      onChange={onChange}
      label={label}
      LabelProps={{ titleBold: true, grayoutTitle }}
      InputProps={{
        endAdornment: (score != null || loadingScore) && (
          <InputAdornment position="end">
            <Score
              className={styles.score}
              score={score}
              loading={loadingScore}
              size={SCORE_SIZE.large}
              generationToolIcon={<IconOverlayText className={styles.toolIcon} />}
            />
          </InputAdornment>
        ),
      }}
      disabled={disabled}
      {...restProps}
    />
  );
};

ScoredTextField.displayName = 'ScoredTextField';
ScoredTextField.propTypes = propTypes;
ScoredTextField.defaultProps = defaultProps;
